module.exports = __webpack_public_path__ + "e770d4df52b2d2d6777cfda7ab974679.png";